module.exports = "<fan-proyecto-colaboradores-importar-procesador-item\r\n    ng-repeat=\"item in $ctrl.resultados track by item.indice\"\r\n    data=\"item\"></fan-proyecto-colaboradores-importar-procesador-item>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fan/proyecto/components/colaboradores/importar/procesador/template.html
// module id = 368
// module chunks = 0